import React from 'react'
import styled from 'styled-components'
import {ChevronDown} from 'react-feather'

import {formatMessage} from '../../i18n'
import Text from './Text'
import Checkbox from './Checkbox'

const MultiSelectTriggerWrapper = styled.div`
  position: relative;
  margin: 8px 0 0 0;
`

const MultiSelectTrigger = styled.button`
  display: block;
  border: 1px solid #d8e1e6;
  width: 100%;
  background-color: #fff;
  padding: 0 40px 0 16px;
  height: 50px;
  font-size: 16px;
  font-family: 'basier_circle', sans-serif;
  cursor: pointer;
  text-align: left;
  outline: none;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${props =>
    props.isEmpty
      ? props.theme.inputfield.colors.input.placeholder
      : props.theme.inputfield.colors.input.color};
`

const MultiSelectChevron = styled(ChevronDown)`
  position: absolute;
  bottom: 12px;
  right: 16px;
  pointer-events: none;
`

const MultiSelectPanel = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  background: #fff;
  border: 1px solid #d8e1e6;
  z-index: 200;
  max-height: 300px;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
`

const MultiSelectOptionRow = styled.div`
  & > label {
    margin-bottom: 0;
    border: none;
    border-radius: 0;
    padding: 10px 16px;
  }
  & > label:hover {
    background-color: #f5f5f5;
  }
`

const MultiSelectDropdown = ({
  label,
  placeholder,
  options,
  selected,
  onToggle,
  required,
  'data-cy': dataCy
}) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const wrapperRef = React.useRef(null)

  React.useEffect(() => {
    const handleClickOutside = e => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [])

  const displayText =
    selected.length > 0
      ? options
          .filter(o => selected.includes(o.value))
          .map(o => o.label)
          .join(', ')
      : null

  return (
    <div ref={wrapperRef} data-cy={dataCy}>
      {label && (
        <div style={{marginLeft: 8}}>
          <Text type="secondary">
            {label}
            {required && (
              <Text type="secondary">{` (${formatMessage('mandatory')})`}</Text>
            )}
          </Text>
        </div>
      )}
      <MultiSelectTriggerWrapper>
        <MultiSelectTrigger
          type="button"
          isEmpty={!displayText}
          onClick={() => setIsOpen(v => !v)}
        >
          {displayText || placeholder}
        </MultiSelectTrigger>
        <MultiSelectChevron />
        {isOpen && (
          <MultiSelectPanel>
            {options.map(option => (
              <MultiSelectOptionRow key={option.value}>
                <Checkbox
                  checked={selected.includes(option.value)}
                  onChange={() => onToggle(option.value)}
                  label={option.label}
                />
              </MultiSelectOptionRow>
            ))}
          </MultiSelectPanel>
        )}
      </MultiSelectTriggerWrapper>
    </div>
  )
}

export default MultiSelectDropdown
